export const exportFileNameFromPath = (path?: string): string => {
  const fileName = (path ?? "").split("/").pop();
  return fileName || "export.csv";
};
